module.exports = __webpack_public_path__ + "img/settings-salary.485b4ac9.svg";